
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/[page]",
      function () {
        return require("private-next-pages/features/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/[page]"])
      });
    }
  